import { render, staticRenderFns } from "./XuYue.vue?vue&type=template&id=31f89cc4&scoped=true&"
import script from "./XuYue.vue?vue&type=script&lang=js&"
export * from "./XuYue.vue?vue&type=script&lang=js&"
import style0 from "./XuYue.vue?vue&type=style&index=0&id=31f89cc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f89cc4",
  null
  
)

export default component.exports